import React from 'react'
import {Link} from 'gatsby'
import Button from '../Button/Button'
import linkedin from '../../assets/svg/ikon-linkedin-hvit.svg'
import './Footer.scss'
import logo from '../../assets/svg/logo.svg'

const Menu = ({menu, title}) => {
	return(
		<div className="FooterMenu">
			<ul>
				{
					title
					? <li><h2>{title}</h2></li>
					: null
				}
				{
					menu.map((item, i) =>
						<li key={i}>
							{
								item.path === '#'
								? 	<h2>{item.label}</h2>
								: <Link to={item.path}>{item.label}</Link>
							}
						</li>
					)
				}
				{ title ? <li><a href="https://lovdata.no/pro/auth/login">Logg inn</a></li> : null }
			</ul>
		</div>
	)
}

export default function Footer({menus}) {

	const toTopOfPage = () => {
		document.body.scrollIntoView({behavior: 'smooth'})
	}

	return(
		<footer className="Footer">
			<h1 className="screen-reader-only">Bunntekst og lenker</h1>
			<div className="inner">
				<div className="section">
					<div className="top content">
						<img src={logo} alt="Lovdata Pro" />
						<h2>Trenger du hjelp?</h2>
						<p className="big">Ta kontakt på <a href="mailto:marked@lovdata.no">marked@lovdata.no</a></p>
						<p><Button url="/prov-gratis/" title="Prøv gratis" target="" color="primary-white" /> </p>
					</div>
				</div>
				<div className="section">
					<div className="top menus">
						{ menus.header ? <Menu title="" menu={menus.header.menuItems.nodes} /> : null }
						<hr/>
						{ menus.primary ? <Menu title="Mer informasjon" menu={menus.primary.menuItems.nodes} /> : null }
					</div>
					<div className="bottom">
						<button className="backToTop" onClick={() => { toTopOfPage() }}>
							Til toppen av siden
							<svg xmlns="http://www.w3.org/2000/svg" width="15.51" height="17.774" viewBox="0 0 15.51 17.774">
								<g id="ikon-neste" transform="translate(-12.879 29.774) rotate(-90)">
									<path d="M35.712,20.634,29.879,14.8,31.8,12.879l7.755,7.755L31.8,28.389l-1.922-1.922Z" transform="translate(-9.781)" fillRule="evenodd"/>
									<path d="M12,27H26.947v2.718H12Z" transform="translate(0 -7.725)" />
								</g>
							</svg>
						</button>
					</div>
				</div>
				<div className="bottom copy">
					<a className="linkedin-link" href="https://www.linkedin.com/company/lovdata/" target="_blank" rel="noreferrer"><img className="linkedin" src={linkedin} alt="Lovdata på LinedIn" /></a>
					<p className="cookies"><Link to="/personvern">Personvernerklæring</Link></p>
					<p>Lovdata Pro er en tjeneste fra Stiftelsen Lovdata — ©{new Date().getFullYear()}</p>
					<p>Design og kode: <a href="//bigfish.no" target="_blank" rel="noreferrer">Big Fish</a></p>
				</div>
			</div>
		</footer>
	)
}